import { render, staticRenderFns } from "./OccupancyOverview.vue?vue&type=template&id=4445412d&"
import script from "./OccupancyOverview.vue?vue&type=script&lang=js&"
export * from "./OccupancyOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports